import { render, staticRenderFns } from "./setInspectorAssistant.vue?vue&type=template&id=164db5b8&scoped=true&"
import script from "./setInspectorAssistant.vue?vue&type=script&lang=js&"
export * from "./setInspectorAssistant.vue?vue&type=script&lang=js&"
import style0 from "./setInspectorAssistant.vue?vue&type=style&index=0&id=164db5b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164db5b8",
  null
  
)

export default component.exports